module.exports = __webpack_public_path__ + "img/schmiedekunst.2c7088db.webp";